import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function PersonalWork() {
  return (
    <>
      <Header />
      
      <section className="project-detail-section">
        <div className="container">
          <div className="project-detail-hero">
            <h1 className="project-detail-title">
              <span className="title-line-1">Personal Design Explorations –</span><br/>
              <span className="title-line-2">UI/UX & Creative Work</span>
            </h1>
            <p className="project-detail-subtitle">These designs were created during my 1st phase when I was just starting and free time as a way to push my creative boundaries and experiment with new visual styles.</p>
          </div>

          <div className="project-detail-content">
            <section className="content-section">
              <p>Each project served as a playground for UI design, branding, and concept development, helping me sharpen my visual thinking and refine my overall design craft.</p>
            </section>

            <section className="content-section">
              <h2>Project One — Fysso</h2>
              <p>Fysso is a design concept centered on modern e-commerce and jewelery presentation. The goal was to build a space where products feel premium yet accessible. By using clean layouts and high-quality imagery, I focused on making the browsing experience feel natural and visually engaging for the user.</p>
              
              <p>Throughout this exploration, I prioritized branding consistency and a clear visual hierarchy. It wasn't just about making things look good; it was about practicing how to guide a user's eye through a mobile interface. This project was a great exercise in balancing minimalist aesthetics with functional UI components.</p>
              
              <div className="project-images-single">
                <img src="/assets/personal-first.jpeg" alt="Fysso Project" />
              </div>
            </section>

            <section className="content-section">
              <h2>Project Two — Energy Drink Instagram Post</h2>
              <p>For this project, I designed a social media post for an energy drink brand, focusing on high-impact visuals and bold typography. The aim was to capture immediate attention in a fast-scrolling feed while keeping the brand's core message clear and energetic.</p>
              
              <p>It was an experiment in high-contrast design and modern digital advertising layouts.</p>
              
              <div className="project-images-single">
                <img src="/assets/personal-second.jpeg" alt="Energy Drink Instagram Post" />
              </div>
            </section>

            <section className="content-section">
              <h2>Project Three — Coffee App Homepage</h2>
              <p>This concept explores a coffee app homepage designed with a focus on warmth and simplicity. I wanted to create a digital atmosphere that mirrors the cozy feeling of a local cafe.</p>
              
              <p>By utilizing inviting visuals and a simplified navigation structure, I aimed to improve my mobile-first design thinking and practice creating intuitive, friendly user interfaces.</p>
              
              <div className="before-redesign-images">
                <img src="/assets/personal-third.jpeg" alt="Coffee App Homepage 1" />
                <img src="/assets/personal-fourth.png" alt="Coffee App Homepage 2" />
              </div>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default PersonalWork;
